import { memo, useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import menusvg from './../../assets/images/sidebar/menu.svg';
import logo from './../../assets/images/logo.png';
import DashboardContext from '../../Context';
import { useCookies } from 'react-cookie';
import { Button, Dropdown, DropdownButton, Modal } from 'react-bootstrap';
import Axios from 'axios';
import axios from 'axios';
/**
 * این کامپوننت برای نمایش منو بالای است
 */
const NavbarUp = ({ handelSlider }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const {
    userName,
    handelLogin,
    authentication,
    urldashboard,
    handelFromTabel,
    handelloding,
    handelAdd,
    handelEdit,
    handelAuthentication,
    titlePage,
  } = useContext(DashboardContext);

  const [, , removeCookie] = useCookies(['Authentication']);

  const history = useHistory();

  const handlelogOut = () => {
    handleClose();
    handelLogin(false);
    handelAuthentication('');
    localStorage.clear();
    sessionStorage.clear();
    removeCookie('Authentication');
    history.push('/login');
  };

  const [dataFech, setDataFech] = useState([]);
  const [serviqShow, setserviqShow] = useState(false);
  const getServiqApiHandler = async () => {
    try {
      const res = await Axios.get(
        `${urldashboard}/Dashboard/ServiqNotificationList`,
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        }
      );

      const data = res.data.data;
      setserviqShow(true);
      setDataFech(data);
    } catch (error) {}
  };

  useEffect(() => {
    if (authentication) {
      getServiqApiHandler();
    }
  }, [authentication]);

  const handelli = () => {
    sessionStorage.setItem('startpage', JSON.stringify(1));
    sessionStorage.setItem('serch', JSON.stringify(''));
    sessionStorage.setItem('pageSize', JSON.stringify(10));
    sessionStorage.setItem('Pagination', JSON.stringify([]));
    sessionStorage.removeItem('customerid');
    handelFromTabel({});
    handelloding(true);
    handelAdd(false);
    handelEdit('');
  };

  return (
    <nav className='navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row'>
      <div className='navbar-brand-wrapper d-flex align-items-center justify-content-between'>
        <Link className='navbar-brand brand-logo' to='/'>
          <img src={logo} alt='logo' />
        </Link>
        <Link className='navbar-brand brand-logo-mini' to='/'>
          <img src={logo} alt='logo' />
        </Link>

        <button
          className='navbar-toggler navbar-toggler align-self-center'
          type='button'
          onClick={() => handelSlider()}
          data-toggle='minimize'
        >
          <img src={menusvg} alt='hambrgermenu' />
        </button>
      </div>
      <div className='navbar-menu-wrapper d-flex align-items-center justify-content-end'>
        <h4 className='ml-auto' style={{ color: 'black' }}>
          {titlePage}
        </h4>
        <ul className='navbar-nav navbar-nav-right'>
          <li className='nav-item dropdown'>
            {serviqShow && (
              <DropdownButton
                id='dropdown-allrt-button'
                className='profileButtonNavbarTop'
                title={
                  <>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='22'
                      height='22'
                      fill='#961BAA'
                      className='bi bi-envelope'
                      viewBox='0 0 16 16'
                    >
                      <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' />
                    </svg>
                    <span
                      className='count-circle'
                      style={{ color: '#961BAA', marginRight: 4 }}
                    >
                      {dataFech?.others
                        ?.map((res) => res?.count)
                        .reduce(function (a, b) {
                          return a + b;
                        }) ?? 0}
                    </span>
                  </>
                }
              >
                {dataFech
                  ? dataFech?.others?.map((item, index) => {
                      return (
                        <Link
                          to={`/${item.action}`}
                          key={index}
                          onClick={handelli}
                        >
                          <Dropdown.Item
                            className='d-inline-flex'
                            href={`#/action-${index}`}
                          >{`${item.title} (${item.count})`}</Dropdown.Item>
                        </Link>
                      );
                    })
                  : null}
              </DropdownButton>
            )}

            {serviqShow && (
              <DropdownButton
                id='dropdown-allrt-button'
                className='profileButtonNavbarTop'
                title={
                  <>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='22'
                      height='22'
                      fill='#961BAA'
                      className='bi bi-person-circle'
                      viewBox='0 0 16 16'
                    >
                      <path d='M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z' />
                      <path
                        fillRule='evenodd'
                        d='M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z'
                      />
                    </svg>
                    <span
                      className='count-circle'
                      style={{ color: '#961BAA', marginRight: 4 }}
                    >
                      {dataFech?.workers
                        ?.map((res) => res?.count)
                        .reduce(function (a, b) {
                          return a + b;
                        }) ?? 0}
                    </span>
                  </>
                }
              >
                {dataFech
                  ? dataFech?.workers?.map((item, index) => {
                      return (
                        <Link
                          to={`/${item.action}`}
                          key={index}
                          onClick={handelli}
                        >
                          <Dropdown.Item
                            className='d-inline-flex'
                            href={`#/action-${index}`}
                          >{`${item.title} (${item.count})`}</Dropdown.Item>
                        </Link>
                      );
                    })
                  : null}
              </DropdownButton>
            )}
            {serviqShow && (
              <DropdownButton
                id='dropdown-allrt-button'
                className='profileButtonNavbarTop'
                title={
                  <>
                    <i
                      className='fa fa-bell-o'
                      style={{ color: '#961BAA', marginRight: 4 }}
                    ></i>
                    <span className='count-circle' style={{ color: '#961BAA' }}>
                      {dataFech?.orders
                        ?.map((res) => res?.count)
                        .reduce(function (a, b) {
                          return a + b;
                        }) ?? 0}
                    </span>
                  </>
                }
              >
                {dataFech
                  ? dataFech?.orders?.map((item, index) => {
                      return (
                        <Link
                          to={`/${item.action}`}
                          key={index}
                          onClick={handelli}
                        >
                          <Dropdown.Item
                            className='d-inline-flex'
                            href={`#/action-${index}`}
                          >{`${item.title} (${item.count})`}</Dropdown.Item>
                        </Link>
                      );
                    })
                  : null}
              </DropdownButton>
            )}
          </li>
          <li className='nav-item dropdown'>
            <DropdownButton
              id='dropdown-profile-button'
              className='profileButtonNavbarTop'
              title={userName}
            >
              <Dropdown.Item href='#/action-2' onClick={handleShow}>
                <li className='profile-item'>
                  <p className='profile-dropdown-link'>
                    <div className='d-flex align-items-center'>
                      <i className='mdi mdi-power text-dark'></i>
                      <div>
                        <h5 className='item-title mt-0'>خروج</h5>
                      </div>
                    </div>
                  </p>
                </li>
              </Dropdown.Item>
            </DropdownButton>
          </li>
        </ul>
        <button
          className='navbar-toggler navbar-toggler-right d-lg-none align-self-center'
          type='button'
          data-bs-toggle='offcanvas'
          onClick={() => handelSlider()}
        >
          <img src={menusvg} alt='' className='' />
        </button>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>خروج از داشبورد سرویک</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          آیا واقعا میخواهید از داشبورد سرویک خارج شوید!!!
        </Modal.Body>
        <Modal.Footer>
          <Button variant='danger' onClick={handleClose}>
            خیر
          </Button>
          <Button variant='success' onClick={handlelogOut}>
            بله
          </Button>
        </Modal.Footer>
      </Modal>
    </nav>
  );
};
export default memo(NavbarUp);
